import env from '@/env.js'
import getAlovaInstanceWithAuth from '@/helpers/getAlovaInstanceWithAuth'

const CHAT_ORCHESTRATOR_PATH = env('CHAT_ORCHESTRATOR_PATH')
const BASE_URL = CHAT_ORCHESTRATOR_PATH ? `${env('API_BASE_URL')}${CHAT_ORCHESTRATOR_PATH}` : null
const alovaInstance = BASE_URL ? getAlovaInstanceWithAuth(BASE_URL) : null

export default {
  getSettings: () => {
    return alovaInstance.Get('/auth/settings', {
      name: 'getChatOrchestratorSettings',
      hitSource: undefined
    })
  }
}
